const NETWORK_ERROR = "Network Error";
const SESSION_EXPIRES = -1011;
const PERMISSION_DENIED = -1005;
const SUCCESSFUL = 200;

export { NETWORK_ERROR, SESSION_EXPIRES, PERMISSION_DENIED, SUCCESSFUL };
